import React, { useEffect, useState } from 'react';
import { Star, Clock, User, Play, Heart, ChevronRight, ShoppingBag, ShoppingCart, PersonStanding, UserRoundCheck, ClockArrowUp } from 'lucide-react';

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

/**
 * CourseCard
 * A sleek, responsive course card built with Tailwind CSS.
 * Props:
 *  - course: {
 *      id, title, subtitle, author, duration (e.g. '3h 20m'),
 *      lessons (number), rating (0-5), reviews (number),
 *      image (url), tags: string[], price (string - 'Free' or '₹199'),
 *      progress (0-100) optional
 *    }
 *  - onEnroll(courseId)
 *  - layout: 'compact' | 'regular' (optional)
 *
 * Default export is the component. This file uses Tailwind utility classes.
 */

export default function CourseCardV1({ courseThemeCard1Object, course, onEnroll = () => {}, layout = 'regular' }) {
  const {
    id,
    title = 'Untitled Course',
    subtitle = '',
    author = 'Unknown',
    duration = '',
    lessons = 0,
    rating = 0,
    reviews = 0,
    image = 'https://placehold.co/600x400?text=Course+Image',
    tags = [],
    price = 'Free',
    progress = null,
  } = course || {};

  const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};
  return (

    <>   <div className="ty-root">
      <style>{`

    :root{
  --card-bg: 
  --card-border: #e6e9ee;
  --muted: #6b7280;
  --accent: #7c3aed; /* violet */
  --accent-2: #06b6d4; /* teal */
  --radius: 16px;
}

.course-card{
  display: grid;
  grid-template-columns: 1fr;
  max-width: 360px;
  background: ${courseThemeCard1Object?.layoutCard?.layoutBG?.color};;
   border:${courseThemeCard1Object?.layoutCard?.borderCard?.borderWidth?.value}px ${courseThemeCard1Object?.layoutCard?.borderCard?.borderType} ${courseThemeCard1Object?.layoutCard?.borderCard?.borderColor?.color};
           border-top-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomRight?.value+"px"};
 
  box-shadow:${courseThemeCard1Object?.layoutCard?.layoutShadow?.horizontal?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.vertical?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.blur?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.spread?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.shadowColor?.color} ${courseThemeCard1Object?.layoutCard?.layoutShadow?.inset?"inset":""};
        
  
}

.course-card--compact{
  grid-template-columns: 120px 1fr;
}

.course-card__media{
  position: relative;
 
}

.course-card--compact .course-card__media{
  height: auto;
}

.course-card__image{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.course-card__tags{
  position: absolute;
  left: 2px;top:2px;
  margin-top: 2px;margin-bottom:2px;
  display: flex;flex-wrap:wrap;
  gap: 5px;
}

.course-card__tag{
  background: ${courseThemeCard1Object?.tags?.buttonBG?.color};
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 9px; 
  color: ${courseThemeCard1Object?.courseTitle?.tagsColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  border:${courseThemeCard1Object?.tags?.border?.borderWidth?.value}px ${courseThemeCard1Object?.tags?.border?.borderType} ${courseThemeCard1Object?.tags?.border?.borderColor?.color};
     border-top-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomRight?.value+"px"};

  box-shadow: 0 2px 6px rgba(2,6,23,0.06);
}

.course-card__enroll-btn{
  position: absolute; display:flex; justify-content:space-between;
  right: 12px;
  bottom: 12px;
  background: ${courseThemeCard1Object?.showMoreBtn?.btnColor?.color};;
  border:${courseThemeCard1Object?.showMoreBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.showMoreBtn?.border?.borderType} ${courseThemeCard1Object?.showMoreBtn?.border?.borderColor?.color};
  
  padding: 8px 12px; border-top-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomRight?.value+"px"};
 
  color: ${courseThemeCard1Object?.showMoreBtn?.iconColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(2,6,23,0.08);
}

.course-card__body{
  padding: 16px;
}

.course-card__title{
  margin: 0;
  font-size: 18px;
  line-height: 1.15;
  color: ${courseThemeCard1Object?.courseTitle?.titleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
}

.course-card__subtitle{
  margin: 6px 0 0;
  color: var(--muted);
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.subtitleFont?.family?.fontFamily};;
  font-size: 13px;
}

.course-card__meta{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.course-card__meta-left{
  display: flex;
  gap: 12px;    color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
 

}

.course-card__meta-item{
  display: flex; 
  align-items: center;font-size:11px;
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  gap: 5px;
}

.course-card__rating{
  font-weight: 600; display:flex; justify-content:center;align-items:center;gap:5px;
   color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-size: 13px;  
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card__progress{
  margin-top: 12px;
}

.course-card__progress-row{
  display:flex;
  justify-content: space-between;
  font-size: 12px; 
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
}

.course-card__progress-bar{
  height: 8px;
  background: #eef2ff;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 6px;
}

.course-card__progress-fill{
  height: 100%;
  background: ${courseThemeCard1Object?.cardTheme?.cardThemeBG?.color};;
}

.course-card__footer{
  margin-top: 14px;position:relative;
  display:flex;
  justify-content: space-between;
  align-items: center;
}

.course-card__price{
  font-weight: 700;min-width:60px;
     color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card__lessons{
  font-size: 11px;
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card__cta{
  background: ${courseThemeCard1Object?.buyNowBtn?.btnBG?.color};
  color: ${courseThemeCard1Object?.buyNowBtn?.btnColor?.color};
    
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
 
  border:${courseThemeCard1Object?.buyNowBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.buyNowBtn?.border?.borderType} ${courseThemeCard1Object?.buyNowBtn?.border?.borderColor?.color};
  
  ;font-size:12px;
  padding: 10px 10px;width:80px;
    border-top-left-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.bottomRight?.value+"px"};
 
  font-weight: 700;
  cursor: pointer;
}

.course-card__wishlist,.course-card__cart{background: ${courseThemeCard1Object?.wishListCartBtn?.btnColor?.color?courseThemeCard1Object?.wishListCartBtn?.btnColor?.color:"#222222"};
  color: white;
  border:${courseThemeCard1Object?.wishListCartBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.wishListCartBtn?.border?.borderType} ${courseThemeCard1Object?.wishListCartBtn?.border?.borderColor?.color};
  
  
           border-top-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomRight?.value+"px"};
 padding:5px;width:40px;height:40px;
 display:flex;justify-content:center;align-items:center;
  font-weight: 700;
  cursor: pointer;}
/* Responsive tweaks */
@media (max-width: 520px){
  .course-card{ max-width: 100%; }
  .course-card__media{ height: 160px; }
  .course-card__title{ font-size: 16px; }
}
      .ty-root{position:absolute;z-index:999999;top:0px;left:0px;right:0px;bottom:0px;;}
        .ty-root{
          display:flex;align-items:center;justify-content:center;
          font-family: Arial, sans-serif;
          background:#f9fafb;
          color:#333;
          padding:0px;
        }
        .ty-card{  position:relative;
          max-width:500px;
          width:100%;display:flex;justify-content:center;
          border-radius:8px;
          padding:0px;
          text-align:center;
        }
        .ty-icon{
          width:70px;height:70px; margin:0 auto 20px auto; border-radius:50%;
          background:#d1fae5; display:flex;align-items:center;justify-content:center;
        }
        .ty-check{
          width:30px;height:15px; border-left:4px solid #10b981; border-bottom:4px solid #10b981;
          transform:rotate(-45deg);margin-top:-14px;
        }
        .ty-title{font-size:22px;margin:0 0 10px 0;color:#111}
        .ty-sub{margin:0 0 20px 0;font-size:15px;color:#555}
        .ty-actions{display:flex;gap:12px;justify-content:center}
        .btn{
          padding:10px 18px; border:none; border-radius:6px; font-weight:600; cursor:pointer;
        }
        .btn-primary{background:#3b82f6;color:#fff}
        .btn-ghost{position:absolute;right:10px;top:10px;color:#fff;cursor:pointer;
        background:#222222;;width:30px;height:30px;border-radius:50%;display:flex;justify-content:center;align-items:center;}
      `}</style>

      <div className="ty-card">
   <article className={`course-card ${courseThemeCard1Object?.compact?.status ? 'course-card--compact' : ''}`} aria-labelledby={`course-${id}-title`}>
<div className="course-card__media">


 <ImageFallFB  boxShadow={``}
                  src={image}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={courseThemeCard1Object?.compact?.status?"3/4":
                  courseThemeCard1Object?.image?.aspectRatio?courseThemeCard1Object?.image?.aspectRatio?.value:""
                  }
                  borderRadius={ courseThemeCard1Object?.image?.borderRadius
                  }/>
         
{!courseThemeCard1Object?.compact?.status?<div className="course-card__tags">
{tags?.map((t) => (
<span key={t} className="course-card__tag">{t}</span>
))}
</div>:""}


<button className="course-card__enroll-btn" onClick={() => onEnroll(id)} aria-label={`Enroll in ${title}`}>
<ChevronRight  size={16} color={courseThemeCard1Object?.showMoreBtn?.iconColor?.color} />  {courseThemeCard1Object?.showMoreBtn?.title} 
</button>
</div>


<div className="course-card__body">
<header>
<h3 id={`course-${id}-title`} className="course-card__title">{title}</h3>
{subtitle && <p className="course-card__subtitle">{subtitle}</p>}
{courseThemeCard1Object?.compact?.status?<div className="course-card__tags" style={{position:"relative"}}>
{tags?.map((t) => (
<span key={t} className="course-card__tag">{t}</span>
))}
</div>:""}
</header>

<div className="course-card__meta">
<div className="course-card__meta-left">
<div className="course-card__meta-item"><UserRoundCheck size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> <span>{author}</span></div>
<div className="course-card__meta-item"><ClockArrowUp size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> <span>{duration}</span></div>
</div>
<div className="course-card__rating"> <div><Star size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> </div> <div>{rating.toFixed(1)} <small>({reviews})</small></div></div>
</div>


{showProgress && (
<div className="course-card__progress">
<div className="course-card__progress-row">
<span>Progress</span>
<span>{progress}%</span>
</div>
<div className="course-card__progress-bar">
<div className="course-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>
)}


<footer className="course-card__footer">
<div>
<div className="course-card__price">{price}</div>
<div className="course-card__lessons">{lessons} lessons</div>
</div>


<div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}>
<button className="course-card__cart" onClick={() => onEnroll(id)}><ShoppingCart size={26} color={courseThemeCard1Object?.wishListCartBtn?.iconColor?.color?courseThemeCard1Object?.wishListCartBtn?.iconColor?.color:"#444444"} /></button>
<button className="course-card__wishlist" onClick={() => onEnroll(id)}><Heart size={26} color={courseThemeCard1Object?.wishListCartBtn?.iconColor?.color?courseThemeCard1Object?.wishListCartBtn?.iconColor?.color:"#444444"} /></button>
<button className="course-card__cta" onClick={() => onEnroll(id)}>{courseThemeCard1Object?.buyNowBtn?.title}</button>
</div>
</footer>
</div>
</article></div></div>

    </>
  );
}

/*
Example usage:

import CourseCard from './CourseCard';

const sample = {
  id: 'c1',
  title: 'Build Modern Web Apps with React',
  subtitle: 'A hands-on project-based course',
  author: 'Kaushal Gedam',
  duration: '3h 20m',
  lessons: 24,
  rating: 4.6,
  reviews: 124,
  image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c',
  tags: ['React', 'Frontend'],
  price: '₹199',
  progress: 42,
};

<CourseCard course={sample} onEnroll={(id) => console.log('Enroll', id)} />
*/
